export const BET         = 'BET';
export const BET_LOCKED  = 'BET_LOCKED';
export const RACE        = 'RACE';
export const DELAY       = 'DELAY';
export const JACKPOT     = 'JACKPOT';
